import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { LinkAppearance } from '../../types'
import type { InfoBoxBorderColours } from '../InfoBox/InfoBox.utils'
import { BasicInfoDownload } from './components/BasicInfoDownload'
import type { File } from './components/ExtendedInfoDownload'
import { ExtendedInfoDownload } from './components/ExtendedInfoDownload'

export const Download: FunctionComponent<DownloadProps> = ({
  file,
  url = '',
  label = 'Download',
  extended,
  buttonAppearance = 'secondary',
  infoBoxBorderColour = 'blue',
  className,
  ...rest
}) => {
  const Child = extended ? ExtendedInfoDownload : BasicInfoDownload

  return (
    <section className={classnames(className)} data-testid="download" {...rest}>
      <Child
        file={file}
        url={url}
        label={label}
        buttonAppearance={buttonAppearance}
        infoBoxBorderColour={infoBoxBorderColour}
      />
    </section>
  )
}

///////// IMPLEMENTATION /////////

export type DownloadProps = {
  file: File
  url?: string
  label?: string
  extended?: boolean
  buttonAppearance?: LinkAppearance
  infoBoxBorderColour?: InfoBoxBorderColours
  className?: string
  [key: `data-${string}`]: string | undefined
} & ComponentPropsWithoutRef<'section'>
